import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="bg-gray-50 min-h-screen"> {/* A light background for the whole page */}
      {/* Hero Section for Title */}
      <div className="bg-blue-900 py-16 sm:py-24 text-white text-center">
        <h1 className="text-3xl sm:text-4xl md:text-5xl  font-extrabold tracking-tight"> {/* Removed -mt-20 here for consistency */}
          Privacy Policy
        </h1>
      </div>

      {/* Main Content Area - Card-like structure */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 -mt-14 sm:-mt-32 relative z-10">
        <div className="bg-white shadow-xl rounded-lg p-6 sm:p-8 md:p-12">
          <p className="text-gray-700 mb-8 text-base sm:text-lg leading-relaxed">
            At Nadezhda Ventures Pvt. Ltd. ("we", "our", "us"), accessible from{' '}
            <a href="https://www.nadezhda.in" className="text-blue-600 hover:text-blue-800 transition-colors duration-200 underline" target="_blank" rel="noopener noreferrer">
              https://www.nadezhda.in
            </a>
            , we are committed to protecting your personal information and your right to privacy. This Privacy Policy explains what information we collect, how we use it, and what rights you have in relation to it.
          </p>
          <p className="text-gray-700 mb-8 text-base sm:text-lg leading-relaxed">
            By using our website, you agree to the collection and use of information in accordance with this policy.
          </p>

          {/* --- Section 1: Information We Collect --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              1. Information We Collect
            </h2>
            <p className="text-gray-700 mb-4 leading-relaxed text-base sm:text-lg">
              We collect information that you provide directly to us when you:
            </p>
            <ul className="list-disc list-inside text-gray-700 mb-4 ml-4 sm:ml-6 space-y-2 text-base sm:text-lg">
              <li>Fill out contact forms or request a consultation</li>
              <li>Subscribe to our newsletter</li>
              <li>Apply for a job or partnership</li>
              <li>Communicate with us via email, phone, or other channels</li>
            </ul>
            <p className="text-gray-700 mb-4 leading-relaxed text-base sm:text-lg">
              The information may include:
            </p>
            <ul className="list-disc list-inside text-gray-700 mb-4 ml-4 sm:ml-6 space-y-2 text-base sm:text-lg">
              <li><strong className="font-semibold">Full Name</strong></li>
              <li><strong className="font-semibold">Email Address</strong></li>
              <li><strong className="font-semibold">Phone Number</strong></li>
              <li><strong className="font-semibold">Business Details</strong></li>
              <li><strong className="font-semibold">Message Content</strong></li>
              <li><strong className="font-semibold">Resume/CV</strong> (if applicable)</li>
            </ul>
            <p className="text-gray-700 mb-4 leading-relaxed text-base sm:text-lg">
              We may also collect certain non-personal data automatically, such as:
            </p>
            <ul className="list-disc list-inside text-gray-700 ml-4 sm:ml-6 space-y-2 text-base sm:text-lg">
              <li><strong className="font-semibold">IP address</strong></li>
              <li><strong className="font-semibold">Browser type</strong></li>
              <li><strong className="font-semibold">Pages visited</strong></li>
              <li><strong className="font-semibold">Time and date of your visit</strong></li>
              <li><strong className="font-semibold">Referring site</strong></li>
            </ul>
          </div>

          {/* --- Section 2: How We Use Your Information --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              2. How We Use Your Information
            </h2>
            <p className="text-gray-700 mb-4 leading-relaxed text-base sm:text-lg">
              We use your information to:
            </p>
            <ul className="list-disc list-inside text-gray-700 ml-4 sm:ml-6 space-y-2 text-base sm:text-lg">
              <li>Respond to your queries or service requests</li>
              <li>Improve our website and user experience</li>
              <li>Send newsletters and updates (only if you opt-in)</li>
              <li>Analyze user behavior for website optimization</li>
              <li>Recruit for open positions or evaluate collaborations</li>
            </ul>
          </div>

          {/* --- Section 3: Sharing of Information --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              3. Sharing of Information
            </h2>
            <p className="text-gray-700 mb-4 leading-relaxed text-base sm:text-lg">
              We do not sell, rent, or trade your personal information. We may share your data with:
            </p>
            <ul className="list-disc list-inside text-gray-700 ml-4 sm:ml-6 space-y-2 text-base sm:text-lg">
              <li><strong className="font-semibold">Service providers</strong> who assist in operating our website and services</li>
              <li><strong className="font-semibold">Legal authorities</strong>, if required by law or to protect our rights</li>
              <li><strong className="font-semibold">Third parties</strong> with your consent</li>
            </ul>
          </div>

          {/* --- Section 4: Cookies and Tracking --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              4. Cookies and Tracking
            </h2>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              We may use <strong className="font-semibold">cookies</strong> and similar technologies to improve your Browse experience and analyze website traffic. You can control cookie settings through your browser.
            </p>
          </div>

          {/* --- Section 5: Data Retention --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              5. Data Retention
            </h2>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              We retain your personal information only as long as necessary to fulfill the purposes outlined in this policy, unless a longer retention period is required by law.
            </p>
          </div>

          {/* --- Section 6: Data Security --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              6. Data Security
            </h2>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              We use <strong className="font-semibold">industry-standard measures</strong> to protect your information. However, no electronic transmission or storage system is 100% secure, and we cannot guarantee absolute security.
            </p>
          </div>

          {/* --- Section 7: Your Rights --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              7. Your Rights
            </h2>
            <p className="text-gray-700 mb-4 leading-relaxed text-base sm:text-lg">
              Depending on your location, you may have the right to:
            </p>
            <ul className="list-disc list-inside text-gray-700 ml-4 sm:ml-6 space-y-2 text-base sm:text-lg">
              <li>Access the personal data we hold about you</li>
              <li>Correct or update your data</li>
              <li>Request deletion of your data</li>
              <li>Withdraw consent at any time</li>
              <li>Lodge a complaint with a data protection authority</li>
            </ul>
            <p className="text-gray-700 mt-4 leading-relaxed text-base sm:text-lg">
              To exercise these rights, contact us at{' '}
              <a href="mailto:contact@nadezhda.in" className="text-blue-600 hover:text-blue-800 transition-colors duration-200 underline">
                contact@nadezhda.in
              </a>.
            </p>
          </div>

          {/* --- Section 8: Third-Party Links --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              8. Third-Party Links
            </h2>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              Our website may contain links to <strong className="font-semibold">third-party websites</strong>. We are not responsible for the privacy practices of those websites.
            </p>
          </div>

          {/* --- Section 9: Children’s Privacy --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              9. Children’s Privacy
            </h2>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              We do not knowingly collect personal information from children under 13. If you believe we have collected such data, please contact us immediately.
            </p>
          </div>

          {/* --- Section 10: Changes to This Policy --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              10. Changes to This Policy
            </h2>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              We may update this Privacy Policy from time to time. Changes will be posted on this page with the updated effective date.
            </p>
          </div>

          {/* --- Section 11: Contact Us --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              11. Contact Us
            </h2>
            <p className="text-gray-700 mb-2 leading-relaxed text-base sm:text-lg">
              If you have any questions or concerns about this Privacy Policy, you may contact us at:
            </p>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              <strong className="font-semibold">Nadezhda Ventures Pvt. Ltd.</strong>
            </p>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              <strong className="font-semibold">Email:</strong>{' '}
              <a href="mailto:contact@nadezhda.in" className="text-blue-600 hover:text-blue-800 transition-colors duration-200 underline">
                contact@nadezhda.in
              </a>
            </p>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              <strong className="font-semibold">Website:</strong>{' '}
              <a href="https://www.nadezhda.in" className="text-blue-600 hover:text-blue-800 transition-colors duration-200 underline" target="_blank" rel="noopener noreferrer">
                https://www.nadezhda.in
              </a>
            </p>
          </div>

          <p className="text-center text-gray-600 mt-10 text-sm sm:text-base">
            Last updated: July 30, 2025
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;